var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimpleDataTable',{attrs:{"clickable-title":true,"title":'Müşteri Senetleri',"description":'',"dataList":_vm.chequeSumReportData,"dataHeaders":_vm.chequeSumReportHeaders,"loading":_vm.chequeSumReportDataLoading,"error-message":_vm.errorMessage}})
}
var staticRenderFns = []

export { render, staticRenderFns }